// GENERAL
import React from "react";
import { getFontAwesomeIcon } from "../../../../../utils";

// COMPONENTS
import {
	BaseText,
	BaseContainer,
	BaseButton,
	BaseModal,
	AddNotesForm,
} from "../../../../../components";

// TYPES
import { ApprovalNotesModalProps } from "../types";

const ApprovalNotesModal: React.FC<ApprovalNotesModalProps> = ({
	adminNotes,
	activeUuid,
	toggleViewAllNotes,
	setRefetchData,
}) => {
	///// CLASS NAMES /////
	const parentContainerClasses = `fixed inset-0 z-50 flex flex-col items-center justify-center`;
	const containerClasses = `flex w-[1020px] h-[800px] flex-col items-start bg-white p-5 rounded-xl border border-gray-200`;
	return (
		<BaseModal
			containerClassNames="overflow-auto"
			header={<></>}
			isOpen={true}
			onClose={toggleViewAllNotes}
			children={
				<div className={parentContainerClasses}>
					<BaseContainer
						columnContainerClasses={containerClasses}
						columnShape="semi-rounded"
						borderColor="navy-200"
						isDisabled={false}
					>
						<div className="flex w-full items-center justify-between">
							<BaseText
								text={`Notes (${adminNotes?.length})`}
								fontFamily="font-omnes-medium"
								tag="h1"
								size="text-lg"
								color="text-navy-500"
								additionalClasses=""
							/>
							<BaseButton
								text=""
								bgColor="bg-white"
								iconAriaLabel="Close"
								icon={getFontAwesomeIcon("Xmark", "regular")}
								as="button"
								onClick={() => toggleViewAllNotes()}
								iconClasses="text-lg pr-0 size-3 text-navy-300 hover:text-navy-500 flex items-center justify-center"
							/>
						</div>

						<AddNotesForm
							notesData={adminNotes}
							openViewAllNotes={toggleViewAllNotes}
							showBottomNoteCount={false}
							notesPlacementBottom={false}
							refetchData={() =>
								setRefetchData((prevState) => !prevState)
							}
							notesListMaxHeight="h-[600px] overflow-scroll"
							salesOrderUuid={activeUuid}
							addNoteButtonStyles={"bg-gray-100"}
						/>
					</BaseContainer>
				</div>
			}
		/>
	);
};

export default ApprovalNotesModal;
